import React from "react";
import { Helmet } from "react-helmet";

const TransactionSEO = () => {
  return (
     <Helmet>
        {/* Page title optimized for the transaction page */}
        <title>Betpro Plus Transactions - Track Your Payments</title>
        <link rel="icon" href="https://betprowallet.pk/favicon.ico" />

        {/* Canonical tag */}
        <link rel="canonical" href="https://betprowallet.pk/transactions" />

        {/* Meta description focusing on viewing and managing transactions */}
        <meta name="description" content="Track and manage your transactions with Betpro Plus. 🏦 View your deposit and withdrawal history easily on Betprowallet.pk for a transparent and secure betting experience." />

        {/* Meta keywords for search engine optimization */}
        <meta name="keywords" content="Betpro Plus transactions, track payments, transaction history, manage deposits and withdrawals, Betprowallet.pk transactions" />

        {/* Meta author */}
        <meta name="author" content="Betpro Plus" />

        {/* Open Graph meta tags for social media sharing */}
        <meta property="og:title" content="Betpro Plus Transactions - Track Your Payments" />
        <meta property="og:description" content="Easily track and manage your transaction history with Betpro Plus. View deposits, withdrawals, and stay updated on your account activity with Betprowallet.pk." />
        <meta property="og:url" content="https://betprowallet.pk/transactions" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://betprowallet.pk/bpthumb2.jpg" />

        {/* Twitter Card for sharing on Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Betpro Plus Transactions - Track Your Payments" />
        <meta name="twitter:description" content="Monitor and manage your transaction history easily on Betprowallet.pk. Transparent records for all deposits and withdrawals with Betpro Plus." />
        <meta name="twitter:image" content="https://betprowallet.pk/bpthumb2.jpg" />

        {/* Structured Data for SEO */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Betpro Plus Transactions - Track Your Payments",
        "url": "https://betprowallet.pk/transactions",
        "description": "Easily track and manage your Betpro Plus transaction history. Stay updated on deposits, withdrawals, and all account activities.",
        "publisher": {
          "@type": "Organization",
          "name": "Betpro Plus"
        }
      }
    `}
        </script>


      </Helmet>
);
};

export default TransactionSEO;
